import { actionTypes, UserEntersDeliveryPointId } from "./Actions";

const userEntersDeliveryPointId: UserEntersDeliveryPointId = (
  deliveryPointId: string
) => ({
  deliveryPointId,
  type: actionTypes.USER_ENTERS_DELIVERY_POINT_ID
});

export default userEntersDeliveryPointId;
